import { defineMessages } from 'react-intl';
export default defineMessages({
    alsoAvailableOn: {
        id: 'landing.alsoAvailableOn',
        defaultMessage: 'Also available on:'
    },
    featureAlertsDescription: {
        id: 'landing.featureAlertsDescription',
        defaultMessage: 'Set custom thresholds for any metric. Get notified when temperature drops, rain starts, or wind picks up.'
    },
    featureAlertsTitle: {
        id: 'landing.featureAlertsTitle',
        defaultMessage: 'Smart Alerts'
    },
    featureAnalyticsDescription: {
        id: 'landing.featureAnalyticsDescription',
        defaultMessage: 'Interactive charts, trend analysis, and detailed statistics. Dive deep into temperature, humidity, pressure, rain, and wind data.'
    },
    featureAnalyticsTitle: {
        id: 'landing.featureAnalyticsTitle',
        defaultMessage: 'Advanced Analytics'
    },
    featureExportDescription: {
        id: 'landing.featureExportDescription',
        defaultMessage: 'Get all your weather data by email as an Excel spreadsheet, ready for further analysis in Excel, Google Sheets, or your favorite tools.'
    },
    featureExportTitle: {
        id: 'landing.featureExportTitle',
        defaultMessage: 'Export Your Data'
    },
    featureForecastDescription: {
        id: 'landing.featureForecastDescription',
        defaultMessage: 'Access {count, plural, one {#+ professional forecast model} other {#+ professional forecast models}} including ECMWF, GFS, and regional models. Compare them side-by-side to make your own predictions.'
    },
    featureForecastTitle: {
        id: 'landing.featureForecastTitle',
        defaultMessage: 'Compare Forecast Models'
    },
    featureHistoryDescription: {
        id: 'landing.featureHistoryDescription',
        defaultMessage: 'Access historical data with hourly, daily, and monthly scales. Export it to Excel for research or personal archives.'
    },
    featureHistoryTitle: {
        id: 'landing.featureHistoryTitle',
        defaultMessage: 'Rich History'
    },
    featureMultiBrandDescription: {
        id: 'landing.featureMultiBrandDescription',
        defaultMessage: 'Connect Netatmo, Davis, Tempest, Ecowitt, Ambient Weather, and more. No more switching between apps.'
    },
    featureMultiBrandTitle: {
        id: 'landing.featureMultiBrandTitle',
        defaultMessage: 'All Brands, One App'
    },
    featuresSubtitle: {
        id: 'landing.featuresSubtitle',
        defaultMessage: 'SmartMixin gives you the tools to analyze, compare, and understand your weather data like a pro.'
    },
    featuresTitle: {
        id: 'landing.featuresTitle',
        defaultMessage: 'Built for data lovers'
    },
    finalCtaButton: {
        id: 'landing.finalCtaButton',
        defaultMessage: 'Create Free Account'
    },
    finalCtaSubtitle: {
        id: 'landing.finalCtaSubtitle',
        defaultMessage: 'Join thousands of weather enthusiasts who trust SmartMixin.'
    },
    finalCtaTitle: {
        id: 'landing.finalCtaTitle',
        defaultMessage: 'Ready to dive deeper into your weather data?'
    },
    heroCta: {
        id: 'landing.heroCta',
        defaultMessage: 'Start Free'
    },
    heroDescription: {
        id: 'landing.heroDescription',
        defaultMessage: 'Deep analytics, beautiful charts, and professional forecasts — all your weather stations unified in one powerful app.'
    },
    heroSecondaryCta: {
        id: 'landing.heroSecondaryCta',
        defaultMessage: 'Explore the Map'
    },
    heroTagline: {
        id: 'landing.heroTagline',
        defaultMessage: 'For Weather Enthusiasts'
    },
    heroTitle: {
        id: 'landing.heroTitle',
        defaultMessage: 'See your weather like never before'
    },
    pricingFeatureAdvancedMetrics: {
        id: 'landing.pricingFeatureAdvancedMetrics',
        defaultMessage: 'Advanced metrics'
    },
    pricingComparisonCaption: {
        id: 'landing.pricingComparisonCaption',
        defaultMessage: 'Free and Premium features compared'
    },
    pricingFeatureAlerts: {
        id: 'landing.pricingFeatureAlerts',
        defaultMessage: 'Custom alerts'
    },
    pricingFeatureColumn: {
        id: 'landing.pricingFeatureColumn',
        defaultMessage: 'Feature'
    },
    pricingFeatureExport: {
        id: 'landing.pricingFeatureExport',
        defaultMessage: 'Data export (Excel)'
    },
    pricingFeatureForecastComparison: {
        id: 'landing.pricingFeatureForecastComparison',
        defaultMessage: 'Forecast comparison'
    },
    pricingFeatureForecasts: {
        id: 'landing.pricingFeatureForecasts',
        defaultMessage: 'Forecast models'
    },
    pricingFeatureForecastsFreeTier: {
        id: 'landing.pricingFeatureForecastsFreeTier',
        defaultMessage: '1 model'
    },
    pricingFeatureForecastsPremiumTier: {
        id: 'landing.pricingFeatureForecastsPremiumTier',
        defaultMessage: '{count, plural, one {#+ model} other {#+ models}}'
    },
    pricingFeatureReports: {
        id: 'landing.pricingFeatureReports',
        defaultMessage: 'Analysis & reports'
    },
    pricingFeatureStationComparison: {
        id: 'landing.pricingFeatureStationComparison',
        defaultMessage: 'Station comparison'
    },
    pricingFeatureWidgets: {
        id: 'landing.pricingFeatureWidgets',
        defaultMessage: 'Home screen widgets'
    },
    pricingFeatureYearOverYear: {
        id: 'landing.pricingFeatureYearOverYear',
        defaultMessage: 'Year-over-year analysis'
    },
    pricingFreeCta: {
        id: 'landing.pricingFreeCta',
        defaultMessage: 'Get Started'
    },
    pricingFreePrice: {
        id: 'landing.pricingFreePrice',
        defaultMessage: '0 €'
    },
    pricingMostPopular: {
        id: 'landing.pricingMostPopular',
        defaultMessage: 'Most Popular'
    },
    pricingPremiumCta: {
        id: 'landing.pricingPremiumCta',
        defaultMessage: 'Get Started'
    },
    pricingPremiumDescription: {
        id: 'landing.pricingPremiumDescription',
        defaultMessage: 'From 1.99 €/month — subscribe on web, App Store, or Google Play'
    },
    pricingSubtitle: {
        id: 'landing.pricingSubtitle',
        defaultMessage: 'Start free, upgrade when you need more power.'
    },
    pricingTitle: {
        id: 'landing.pricingTitle',
        defaultMessage: 'Simple, transparent pricing'
    },
    statBrands: {
        id: 'landing.statBrands',
        defaultMessage: 'Brands supported'
    },
    statForecasts: {
        id: 'landing.statForecasts',
        defaultMessage: 'Forecast models'
    },
    statStations: {
        id: 'landing.statStations',
        defaultMessage: 'Weather stations'
    },
    supportedDevicesNote: {
        id: 'landing.supportedDevicesNote',
        defaultMessage: 'Plus more than {count, number} public stations from the World Meteorological Organization network'
    },
    supportedDevicesSubtitle: {
        id: 'landing.supportedDevicesSubtitle',
        defaultMessage: 'Connect your existing weather station in minutes. We support {count, plural, one {# major brand} other {# major brands}} and growing.'
    },
    supportedDevicesTitle: {
        id: 'landing.supportedDevicesTitle',
        defaultMessage: 'Works with your station'
    }
});
